export const ActionTypes = {
    setCompanySearchResults: 'job/SET_COMPANY_SEARCH_RESULTS',
    setLoadingCompanySearchResults: 'job/SET_LOADING_COMPANY_SEARCH_RESULTS',
    setJob: 'job/SET_JOB',
    setLoadingJob: 'job/SET_LOADING_JOB',
    setJobNotFound: 'job/SET_JOB_NOT_FOUND',
    setJobs: 'job/SET_JOBS',
    addJobs: 'job/ADD_JOBS',
    setLoadingJobs: 'job/SET_LOADING_JOBS',
    setSavedFilters: 'job/SET_SAVED_FILTERS',
    setLoadingPostJob: 'job/SET_LOADING_POST_JOB',
    setRecruiterCanPostJobs: 'job/SET_RECRUITER_CAN_POST_JOBS',
    setDailyJobPostViewCount: 'job/SET_DAILY_JOB_POST_VIEW_COUNT',
}